import { createSlice } from '@reduxjs/toolkit';
import { IUser } from '@Data/users/Interfaces';
import { RootState } from '@Services/redux/Store';
import { initialUserState } from './State';

const UserSlice = createSlice({
    name: 'User',
    initialState: initialUserState,
    reducers: {
        setSelectedUser(state, action) {
            state.selectedUser = action.payload;
        },
    },
});

export const UserActions = UserSlice.actions;
export const userState = (state: RootState): IUser => state.user.selectedUser;

export default UserSlice.reducer;
